import * as React from "react";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../utils/Helpers";
import { FocusableItemDirectionEnum } from "../../utils/Focus";
export var PlayerResolutionList = function (_a) {
    var quality = _a.quality, popup = _a.popup, onSetResolution = _a.onSetResolution, onBackPress = _a.onBackPress, resolutionListRef = _a.resolutionListRef;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "resolution-list", ref: resolutionListRef, tabIndex: 0 },
        React.createElement("p", null, quality.toUpperCase()),
        React.createElement("span", { className: "popup", style: "display: " + (popup === "resolution" ? "block" : "none") },
            React.createElement("ul", { id: "resolution-list", "data-direction": "1" },
                React.createElement("li", { className: "popup-title" }, t("player.quality")),
                popup === "resolution"
                    ? ["HD", "SD"].map(function (resolution, index) { return (React.createElement(PlayerResolutionItemView, { active: quality === resolution, focusRaw: ["playerPopup", index], key: index, resolution: resolution, setResolution: onSetResolution, handleBackPress: onBackPress })); })
                    : null))));
};
var PlayerResolutionItemView = function (_a) {
    var active = _a.active, focusRaw = _a.focusRaw, resolution = _a.resolution, setResolution = _a.setResolution, handleBackPress = _a.handleBackPress;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        direction: FocusableItemDirectionEnum.Vertical,
        onKeyDown: function () { return setResolution(resolution); },
        onKeyBack: function () { return handleBackPress(); },
    });
    return (React.createElement("li", { ref: ref, tabIndex: 0, className: active ? "active" : "" }, resolution));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/player/PlayerResolutionList.tsx
// module id = 197
// module chunks = 1